import { updateOrderPaymentApi } from "../api/orderPaymentApi";

export const updateOrderPaymentService = async (data: any, id: string) => {
  try {
    const response = await updateOrderPaymentApi(data, id);
    return response;
  } catch (error: any) {
    console.log("error", error.message);
    throw new Error(error.message);
  }
};
